/*
 * L.Control.Coordinates is used for displaying current mouse coordinates on the map.
 */

// eslint-disable-next-line no-undef
L.Control.Coordinates = L.Control.extend({
    options: {
        position: 'bottomright',
        // decimals used if not using DMS or labelFormatter functions
        decimals: 4,
        // decimalseperator used if not using DMS or labelFormatter functions
        decimalSeperator: '.',
        // label templates for usage if no labelFormatter function is defined
        labelTemplateLat: 'Lat: {y}',
        labelTemplateLng: 'Lng: {x}',
        // label formatter functions
        labelFormatterLat: undefined,
        labelFormatterLng: undefined,
        // switch on/off input fields on click
        enableUserInput: true,
        // use Degree-Minute-Second
        useDMS: false,
        // if true lat-lng instead of lng-lat label ordering is used
        useLatLngOrder: false,
        // if true user given coordinates are centered directly
        centerUserCoordinates: false,
        // leaflet marker type
        // eslint-disable-next-line no-undef
        markerType: L.marker,
        // leaflet marker properties
        markerProps: {}
    },

    onAdd: function (map) {
        this._map = map;

        // eslint-disable-next-line no-undef
        const dom = L.DomUtil;

        const className = 'leaflet-control-coordinates';
        const container = (this._container = dom.create('div', className));
        const options = this.options;

        this._inputcontainer = dom.create('div', 'uiElement input', container);

        const ySpan = dom.create(
            'span',
            'coordinates-container',
            this._inputcontainer
        );
        const xSpan = dom.create(
            'span',
            'coordinates-container',
            this._inputcontainer
        );
        const zSpan = dom.create(
            'span',
            'zoom-container',
            this._inputcontainer
        );

        ySpan.innerHTML = options.labelTemplateLat.replace('{y}', '--');
        xSpan.innerHTML = options.labelTemplateLng.replace('{x}', '--');

        map.on('mousemove', function (event) {
            const lat = event.latlng.lat.toFixed(6);
            const lng = event.latlng.lng.toFixed(6);
            ySpan.innerHTML = options.labelTemplateLat.replace('{y}', lat);
            xSpan.innerHTML = options.labelTemplateLng.replace('{x}', lng);
        });

        const zoom = map.getZoom();
        zSpan.innerHTML = 'Zoom level: ' + Math.round(zoom);

        map.on('zoomend', function (e) {
            const currentZoom = map.getZoom();
            zSpan.innerHTML = 'Zoom level: ' + Math.round(currentZoom);
        });

        return container;
    }
});

// constructor registration
// eslint-disable-next-line no-undef
L.control.coordinates = function (options) {
    // eslint-disable-next-line no-undef
    return new L.Control.Coordinates(options);
};

// map init hook
// eslint-disable-next-line no-undef
L.Map.mergeOptions({
    coordinateControl: false
});

// eslint-disable-next-line no-undef
L.Map.addInitHook(function () {
    if (this.options.coordinateControl) {
        // eslint-disable-next-line no-undef
        this.coordinateControl = new L.Control.Coordinates();
        this.addControl(this.coordinateControl);
    }
});
